/* tslint:disable */
import {
  App,
  Entity,
  Entityrecord,
  Account
} from '../index';

declare var Object: any;
export interface NoteInterface {
  date?: Date;
  text: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  entityId?: any;
  entityrecordId?: any;
  accountId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  entity?: Entity;
  entityrecord?: Entityrecord;
  account?: Account;
}

export class Note implements NoteInterface {
  date: Date;
  text: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  entityId: any;
  entityrecordId: any;
  accountId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  entity: Entity;
  entityrecord: Entityrecord;
  account: Account;
  constructor(data?: NoteInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Note`.
   */
  public static getModelName() {
    return "Note";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Note for dynamic purposes.
  **/
  public static factory(data: NoteInterface): Note{
    return new Note(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Note',
      plural: 'notes',
      properties: {
        date: {
          name: 'date',
          type: 'Date'
        },
        text: {
          name: 'text',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        entityrecordId: {
          name: 'entityrecordId',
          type: 'any'
        },
        accountId: {
          name: 'accountId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
        entityrecord: {
          name: 'entityrecord',
          type: 'Entityrecord',
          model: 'Entityrecord'
        },
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Note.ts